import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
	invalidateNotifications,
	NotificationsKeys,
} from "web_myplann/Api/Notifications/notificatioKeys";
import { patchNotificationsReadAllV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useNotificationMarkAllAsReadMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((filterLastnotificationid: number) =>
			patchNotificationsReadAllV2(filterLastnotificationid),
		),
		onMutate: async () => {
			await Promise.all([
				queryClient.cancelQueries({
					queryKey: NotificationsKeys.infiniteGroupedList(true),
				}),
				queryClient.cancelQueries({ queryKey: NotificationsKeys.count() }),
				queryClient.cancelQueries({
					queryKey: NotificationsKeys.groupedCountAll(),
				}),
			]);
		},
		onSettled: () => {
			invalidateNotifications(queryClient);
		},
	});
};
